import React, { useRef, useContext } from "react";
import { CameraSection } from "../../context/CameraContext";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FiX, FiCheck } from "react-icons/fi";
import { useTranslation } from "react-i18next";
const AddCamera = () => {
  const { t } = useTranslation();
  const { CameraShowHideFunc } = useContext(CameraSection);
  let form = useRef();
  const initialValues = {
    address: "",
    name: "",
  };

  const validationSchema = Yup.object({
    address: Yup.string().required(t("آدرس دوربین را وارد کنید.")),
    name: Yup.string().required(t("نام دوربین را وارد کنید.")),
  });

  const submitForm = () => {};

  return (
    <div>
      <div>
        <i className="circleTop icon-plug text-center m-auto"></i>
        <div className="text-center mt-2">
          <p className="m-0"></p>
        </div>
      </div>
      <div className="my-4" style={{ minHeight: "60vh" }}>
        <Formik
          initialValues={initialValues}
          onSubmit={submitForm}
          validationSchema={validationSchema}
        >
          {(props) => (
            <Form ref={form}>
              <div className="my-4">
                <div className="mb-3">
                  <p className="fn12 mb-1 text-right">{t("آدرس دوربین")}</p>
                  <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                    <input
                      type="text"
                      placeholder=" http://exampl.com"
                      name="address"
                      className="w-100 fn12"
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                    />
                  </div>
                  <ErrorMessage name="address">
                    {(errMsg) => (
                      <div className="text-danger text-right fn10 mt-1">
                        {errMsg}
                      </div>
                    )}
                  </ErrorMessage>
                </div>
                <div>
                  <p className="fn12 mb-1 text-right">{t("نام دوربین")}</p>
                  <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                    <input
                      type="text"
                      placeholder=""
                      name="name"
                      className="w-100 fn12"
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                    />
                  </div>
                  <ErrorMessage name="name">
                    {(errMsg) => (
                      <div className="text-danger text-right fn10 mt-1">
                        {errMsg}
                      </div>
                    )}
                  </ErrorMessage>
                </div>
              </div>
              <div
                className="d-flex flex-wrap justify-content-center"
                style={{ marginTop: "13rem" }}
              >
                <button
                  type="submit"
                  className="border-0 bg-transparent mx-3 d-flex justify-content-center align-items-center flex-column text-center"
                >
                  <span className="profileAddUser bg-white d-block cursor">
                    <FiCheck />
                  </span>
                  <small className="fn12 mt-1">{t("افزودن")}</small>
                </button>
                <div
                  onClick={() => CameraShowHideFunc("firstPage")}
                  className="border-0 bg-transparent mx-3 d-flex justify-content-center align-items-center flex-column text-center"
                >
                  <span className="profileAddUser bg-white d-block cursor">
                    <FiX />
                  </span>
                  <small className="fn12 mt-1">{t("انصراف")}</small>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export { AddCamera };
